import React, { Fragment } from "react";
import {makeStyles} from "@material-ui/core/styles"
import ForegroundImage from "../responsive-carousel/ForegroundImage";
import BackgroundImage from "../responsive-carousel/BackgroundImage";
import TestimonialTextContent from "./TestimonialTextContent";

function TestimonialSlide({ slidedata, heightClass, isForeground, isTimer }) {
  let assetType = slidedata.assetType;
  
  //isForeground=false;// enable this to test No-foreground case
  
  let containerStyle = makeStyles({
    root:{
      justifyContent:"center !important"
    }
  })

  return (
    <div className={`testmonial-slide ${!isForeground ? containerStyle().root : ""} `}>
      
      {/* slide background image */}
      {/* <BackgroundImage image={slidedata.backgroundImage}/> */}
        
      <Fragment>
        <TestimonialTextContent 
        textContent={{
          ...slidedata.textContent

        }} isAlignCenter={false}/>
        {isForeground && <ForegroundImage image={{ src: slidedata.foregroundImage.fgAssetPath, alt: slidedata.foregroundImage.fgAltText }} isTermsAndCondition={false} />}
      </Fragment>

    </div>
  );
}

export default TestimonialSlide;
``